import { render, staticRenderFns } from "./SummaryContents-Loads.vue?vue&type=template&id=7ed7b79a&"
import script from "./SummaryContents-Loads.vue?vue&type=script&lang=js&"
export * from "./SummaryContents-Loads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports